import { HomeArtistsDisplayState } from './display.types';

export const getDefaultDisplay = (): HomeArtistsDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: HomeArtistsDisplayState = getDefaultDisplay();
